<template>
    <section id="features" class="section-padding  bg-gray">
        <div class="container-fluid">
            <div class="section-header text-center container">
                <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">{{$t('menus.Services')}}</h2>
                <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
                <p class="wow fadeInDown" data-wow-delay="0.4s">{{$t('services.subTitle')}}</p>
                <p class="wow fadeInDown" data-wow-delay="0.4s">{{$t('services.subTitle1')}}</p>
                <p class="wow fadeInDown" data-wow-delay="0.4s">{{$t('services.subTitle2')}}</p>
            </div>
            <div class="row">
                <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                    <div class="content-left">
                        <div class="box-item row wow fadeInRight" data-wow-delay="0.3s">
                            <div class="col-9">
                                <div class="text text-right ">
                                    <p>{{$t('services.TARGETED_CASE_MANAGEMENT')}}</p>
                                </div>
                            </div>
                            <div class="col-3">
                  <span class="icon">
                  <img src="../assets/img/v2/services/service-06.svg" alt="TARGETED CASE MANAGEMENT">
                </span>
                            </div>

                        </div>

                        <div class="box-item row wow fadeInLeft" data-wow-delay="0.3s">
                            <div class="col-9">
                                <div class="text text-right">
                                    <p>{{$t('services.INDIVIDUAL_FAMILY')}}</p>
                                    <!--                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
                                </div>
                            </div>
                            <div class="col-3">
                  <span class="icon">
                  <img src="../assets/img/v2/services/service-04.svg" alt="INDIVIDUAL/FAMILY/COUPLE PSYCHOTHERAPY">
                </span>
                            </div>
                        </div>
                        <div class="box-item row wow fadeInLeft" data-wow-delay="0.3s">
                            <div class="col-9">
                                <div class="text text-right">
                                    <p>{{$t('services.PSYCHIATRIC_EVALUATION')}}</p>
                                    <!--                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
                                </div>
                            </div>
                            <div class="col-3">
                  <span class="icon">
                  <img src="../assets/img/v2/services/service-02.svg"
                       alt="PSYCHIATRIC EVALUATION & MEDICATION MANAGEMENT FOR CHILDREN, ADOLESCENTS AND ADULTS/EVALUACION ">
                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 d-none d-md-block">
                    <div class="show-box wow fadeInUp img-center" data-wow-delay="0.3s">
<!--                        <SvgAnimated :svg=animation1 />-->
                            <img src="../assets/img/v2/services-dttcs-03.svg" alt="">
                    </div>
                </div>
                <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                    <div class="content-right">
                        <div class="box-item row wow fadeInLeft" data-wow-delay="0.3s">
                            <div class="col-3">
                  <span class="icon">
                  <img src="../assets/img/v2/services/service-10.svg" alt="PSYCHOREHABILITATIVE SERVICES">
                </span>
                            </div>
                            <div class="col-9">
                                <div class="text text-left ">
                                    <p>{{$t('services.PSYCHOREHABILITATIVE_SERVICES')}}</p>
                                </div>
                            </div>


                        </div>
                        <div class="box-item row wow fadeInRight" data-wow-delay="0.3s">
                            <div class="col-3">
                  <span class="icon">
                  <img src="../assets/img/v2/services/service-03.svg" alt="GROUP PSYCHOTHERAPY">
                </span>
                            </div>
                            <div class="col-9">
                                <div class="text text-left">
                                    <p>{{$t('services.GROUP_PSYCHOTHERAPY')}}</p>
                                    <!--                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>-->
                                </div>
                            </div>

                        </div>
                        <div class="box-item row wow fadeInRight" data-wow-delay="0.3s">
                            <div class="col-3">
                  <span class="icon">
                 <img src="../assets/img/v2/services/service-08.svg" alt="SUPPORT GROUPS">
                </span>
                            </div>
                            <div class="col-9">
                                <div class="text text-left ">
                                    <p>{{$t('services.BEHAVIORAL_ANALISYS')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box-item row wow fadeInRight" data-wow-delay="0.3s">
                            <div class="col-3">
                  <span class="icon">
                      <img src="../assets/img/v2/services/service-07.svg" alt="BEHAVIORAL ANALISYS">

                </span>
                            </div>
                            <div class="col-9">
                                <div class="text text-left ">
                                    <p>{{$t('services.SUPPORT_GROUPS')}}</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div class="container other-service text-center">
                <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
                <h3 style="width: 100%" >
                  <img class="wow fadeInDown" data-wow-delay="0.3s" height="80px" width="80px" src="../assets/img/v2/services/service-09.svg" alt="INSURANCE COVERAGE">
                </h3>
                <h3 class="section-title wow fadeInDown" data-wow-delay="0.3s">{{ $t('services.otherService.title') }}</h3>
                <h5 class="wow fadeInDown" data-wow-delay="0.6s" v-html="$t('services.otherService.txt1')"></h5>
                <h6 class="section-title wow fadeInDown" data-wow-delay="0.8s" v-html="$t('services.otherService.txt2')"></h6>
            </div>
        </div>
    </section>
</template>

<script>
    import SvgAnimated from '../components/SvgAnimationCmp'
    import * as animationData from '../assets/animations/smooth-healthy-dttcs.json';

    export default {
        name: "Services",
        components: {
            SvgAnimated
        },
        data() {
            return {
                animation1: animationData
            }
        }
    }
</script>

<style lang="scss">

</style>
